var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-sm-12 col-md-12 col-lg-12" },
      [
        _c(
          "b-form",
          { attrs: { id: "user_submit" }, on: { submit: _vm.onSubmit } },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Фамилия", "label-for": "last_name" } },
              [
                _c("b-form-input", {
                  attrs: { id: "last_name", size: "sm", type: "text" },
                  model: {
                    value: _vm.user.item.last_name,
                    callback: function($$v) {
                      _vm.$set(_vm.user.item, "last_name", $$v)
                    },
                    expression: "user.item.last_name"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && _vm.lastNameValidateMessage
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v(_vm._s(_vm.lastNameValidateMessage))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Имя", "label-for": "first_name" } },
              [
                _c("b-form-input", {
                  attrs: { id: "first_name", size: "sm", type: "text" },
                  model: {
                    value: _vm.user.item.first_name,
                    callback: function($$v) {
                      _vm.$set(_vm.user.item, "first_name", $$v)
                    },
                    expression: "user.item.first_name"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && _vm.firstNameValidateMessage
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v(_vm._s(_vm.firstNameValidateMessage))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Email", "label-for": "email" } },
              [
                _c("b-form-input", {
                  attrs: { id: "email", size: "sm", type: "text" },
                  model: {
                    value: _vm.user.item.email,
                    callback: function($$v) {
                      _vm.$set(_vm.user.item, "email", $$v)
                    },
                    expression: "user.item.email"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.user.item.email
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Поле Email является обязательным.")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.submitted && _vm.message
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v(_vm._s(_vm.message))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.$currentUser.role == "admin"
              ? _c(
                  "b-form-group",
                  { attrs: { label: "Роль", "label-for": "role" } },
                  [
                    _c(
                      "b-form-select",
                      {
                        staticClass: "filterComponent",
                        attrs: { size: "sm" },
                        on: { change: _vm.changeRole },
                        model: {
                          value: _vm.user.item.role,
                          callback: function($$v) {
                            _vm.$set(_vm.user.item, "role", $$v)
                          },
                          expression: "user.item.role"
                        }
                      },
                      [
                        _c("option", { attrs: { value: "user" } }, [
                          _vm._v("Пользователь")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "leader" } }, [
                          _vm._v("Лидер")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "admin" } }, [
                          _vm._v("Админ")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "account" } }, [
                          _vm._v("Аккаунт")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.roleChanged
                      ? _c(
                          "span",
                          {
                            staticClass: "alert-warning",
                            staticStyle: { "font-size": "10px" }
                          },
                          [
                            _vm._v(
                              "Пожалуйста, убедитесь, что действительно желаете поменять роль этого пользователя!"
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Департамент", "label-for": "department" } },
              [
                _c(
                  "b-form-select",
                  {
                    staticClass: "filterComponent",
                    attrs: { size: "sm" },
                    model: {
                      value: _vm.user.item.department,
                      callback: function($$v) {
                        _vm.$set(_vm.user.item, "department", $$v)
                      },
                      expression: "user.item.department"
                    }
                  },
                  [
                    _c("option", { attrs: { value: "agency" } }, [
                      _vm._v("Agency")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "adkey" } }, [
                      _vm._v("AdKey")
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.$currentUser.role == "admin" && _vm.user.item.role == "leader"
              ? _c(
                  "b-form-group",
                  { attrs: { label: "Подчинённые", "label-for": "users" } },
                  [
                    _c(
                      "v-select",
                      {
                        attrs: {
                          options: _vm.availableUsers,
                          label: "name",
                          required: "",
                          multiple: ""
                        },
                        model: {
                          value: _vm.user.item.subordinates,
                          callback: function($$v) {
                            _vm.$set(_vm.user.item, "subordinates", $$v)
                          },
                          expression: "user.item.subordinates"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "no-options" }, slot: "no-options" },
                          [_vm._v("Совпадений не найдено.")]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Network ID", "label-for": "name" } },
                    [
                      _c("b-form-input", {
                        attrs: { id: "name", size: "sm", type: "number" },
                        model: {
                          value: _vm.user.item.network_partner_id,
                          callback: function($$v) {
                            _vm.$set(_vm.user.item, "network_partner_id", $$v)
                          },
                          expression: "user.item.network_partner_id"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Market ID", "label-for": "name" } },
                    [
                      _c("b-form-input", {
                        attrs: { id: "name", size: "sm", type: "number" },
                        model: {
                          value: _vm.user.item.market_partner_id,
                          callback: function($$v) {
                            _vm.$set(_vm.user.item, "market_partner_id", $$v)
                          },
                          expression: "user.item.market_partner_id"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.user.item.role == "account"
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-6" },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Affise Network API ID",
                            "label-for": "name"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "name", size: "sm", type: "text" },
                            model: {
                              value: _vm.user.item.network_user_id,
                              callback: function($$v) {
                                _vm.$set(_vm.user.item, "network_user_id", $$v)
                              },
                              expression: "user.item.network_user_id"
                            }
                          }),
                          _vm._v(" "),
                          _vm.submitted && _vm.network_user_id_message
                            ? _c("span", { staticClass: "alert-danger" }, [
                                _vm._v(_vm._s(_vm.network_user_id_message))
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-6" },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Affise Market API ID",
                            "label-for": "name"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "name", size: "sm", type: "text" },
                            model: {
                              value: _vm.user.item.market_user_id,
                              callback: function($$v) {
                                _vm.$set(_vm.user.item, "market_user_id", $$v)
                              },
                              expression: "user.item.market_user_id"
                            }
                          }),
                          _vm._v(" "),
                          _vm.submitted && _vm.market_user_id_message
                            ? _c("span", { staticClass: "alert-danger" }, [
                                _vm._v(_vm._s(_vm.market_user_id_message))
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Пароль", "label-for": "newPassword" } },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "newPassword",
                    size: "sm",
                    autocomplete: "new-password",
                    readonly: "",
                    onfocus: "this.removeAttribute('readonly');",
                    onblur: "this.setAttribute('readonly','');",
                    type: "password"
                  },
                  on: {
                    blur: function($event) {
                      return _vm.validateNewPassword()
                    }
                  },
                  model: {
                    value: _vm.newPassword,
                    callback: function($$v) {
                      _vm.newPassword = $$v
                    },
                    expression: "newPassword"
                  }
                }),
                _vm._v(" "),
                _vm.newPasswordMessage
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v(_vm._s(_vm.newPasswordMessage))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Подтверждение пароля",
                  "label-for": "passwordRepeat"
                }
              },
              [
                _c("b-form-input", {
                  attrs: {
                    id: "passwordRepeat",
                    size: "sm",
                    autocomplete: "new-password",
                    readonly: "",
                    onfocus: "this.removeAttribute('readonly');",
                    onblur: "this.setAttribute('readonly','');",
                    type: "password"
                  },
                  on: {
                    blur: function($event) {
                      return _vm.validateRepeatPassword()
                    }
                  },
                  model: {
                    value: _vm.passwordRepeat,
                    callback: function($$v) {
                      _vm.passwordRepeat = $$v
                    },
                    expression: "passwordRepeat"
                  }
                }),
                _vm._v(" "),
                _vm.repeatPasswordMessage
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v(_vm._s(_vm.repeatPasswordMessage))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-checkbox",
              {
                staticClass: "pb-3",
                attrs: {
                  value: "1",
                  "unchecked-value": "0",
                  name: "check-button"
                },
                model: {
                  value: _vm.user.item.deactivated,
                  callback: function($$v) {
                    _vm.$set(_vm.user.item, "deactivated", $$v)
                  },
                  expression: "user.item.deactivated"
                }
              },
              [_vm._v("\n                Неактивен\n            ")]
            ),
            _vm._v(" "),
            _c(
              "b-form-checkbox",
              {
                staticClass: "pb-3",
                attrs: {
                  value: "1",
                  "unchecked-value": "0",
                  name: "check-button"
                },
                model: {
                  value: _vm.user.item.is_hidden,
                  callback: function($$v) {
                    _vm.$set(_vm.user.item, "is_hidden", $$v)
                  },
                  expression: "user.item.is_hidden"
                }
              },
              [_vm._v("\n                Скрыть пользователя\n            ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "float-right",
                attrs: { type: "submit", variant: "primary" }
              },
              [_vm._v("Сохранить\n            ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-errors" })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aec01cd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aec01cd8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/modals/EditUserModal.vue
// module id = 1046
// module chunks = 0